import { Log, LogType } from "./logging.model";
import { LoggingService } from "./logging.service";

export class Logger implements Log {
	constructor(
		private sourceId: string,
		private logger: LoggingService
	) {}

	debug(method: string, message?: string, data?: any) {
		this.log(LogType.Debug, method, message, data);
	}

	info(method: string, message?: string, data?: any) {
		this.log(LogType.Info, method, message, data);
	}

	warn(method: string, message?: string, data?: any) {
		this.log(LogType.Warn, method, message, data);
	}

	error(method: string, message?: string | Error, data?: any) {
		this.log(LogType.Error, method, message, data);
	}

	private log(type: LogType, method: string, message?: string | Error, data?: any) {
		const formattedMessage = this.getFormattedMessage(method, message);
		this.logger.log(type, formattedMessage, data);
	}

	private buildLogMessage(method: string, message?: string): string {
		return message ? `[${this.sourceId}::${method}] ${message}` : `[${this.sourceId}::${method}]`;
	}

	private getFormattedMessage(method: string, message?: string | Error): string | Error {
		if (message instanceof Error) {
			return new FormattedError(this.buildLogMessage(method, message.message), message.stack);
		}

		return this.buildLogMessage(method, message);
	}
}

// Implemented to avoid errors related to message being readonly property
class FormattedError extends Error {
	constructor(message?: string, stack?: string) {
		super(message);
		this.stack = stack;
		Object.setPrototypeOf(this, FormattedError.prototype);
	}
}
